<template>
  <div>
    <modal
      :show.sync="isActiveLocal"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      footerClasses=""
      size="lg"
      bodyClasses=""
      @close="closeModal"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Edit Live URL
      </h6>
      <div>
        <p>Name</p>
        <base-input
          v-model="url_data.name"
          placeholder="Enter Heading"
          class="cust-mb0 mt-2 mb-2"
          :rules="{ required: true }"
          name="name"
        ></base-input>
        <p class="mt-2">Url</p>
        <base-input
          v-model="url_data.url"
          placeholder="Enter URL"
          class="cust-mb0 mt-2 mb-2"
          :rules="{ required: true }"
          name="URL"
        ></base-input>
        <div class="d-flex w-full gap-4 datepickerclass">
          <div class="w-1/2 my-4">
            <b-form-group label="Date:">
              <date-picker
                slot-scope="{ focus, blur }"
                @on-open="focus"
                @on-close="blur"
                required
                :config="{ allowInput: true }"
                placeholder="Select Date"
                v-model="url_data.date"
                class="w-full"
                valueType="format"
              >
              </date-picker>
            </b-form-group>
          </div>
          <div class="w-1/2 my-4">
            <b-form-group label="Time:">
              <date-picker
                v-model="url_data.time"
                format="HH:mm"
                value-type="format"
                type="time"
                class="w-full"
                :config="configdateTimePicker"
                placeholder="HH:mm"
              >
              </date-picker>
            </b-form-group>

            <!-- <b-button type="primary"
          >Create Chapter</b-button -->
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="primary" @click.once="handleEdit()"
          >Edit LIVE</base-button
        >
        <base-button type="secondary" class="ml-auto" @click="closeModal"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      name: "",
      url: "",
      selectdate: "",
      selecttime: "",
      url_data: {},
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
      },
    };
  },
  props: {
    liveedit: Boolean,
    urlData: Object,
    chapter: Object,
  },
  watch: {
    urlData(newVal) {
      this.url_data = { ...newVal };
    },
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.liveedit;
      },
      async set() {
        this.$emit("close-liveedit");
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-liveedit");
    },

    async handleEdit() {
      let loader = this.$loading();
      // console.log("true1");
      let payload = {
        _id: this.url_data._id,
        url: this.url_data.url,
        name: this.url_data.name,
        date: this.url_data.date,
        time: this.url_data.time,
      };
      try {
        const data = await this.$store.dispatch("eLearning/EditLive", payload);
        // console.log("true2");
        if (data.code == 200) {
          loader.close();
          await this.$store.dispatch("eLearning/getChapterByCourseId", {
            id: this.chapter.course[0],
          });

          await this.$store.dispatch("eLearning/GetLive");
          this.$swal.fire({
            title: "Edit",

            text: "Edit Successfully!",

            icon: "success",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.closeModal();
        }
      } catch (err) {
        loader.close();
      }
    },
  },
};
</script>
<style>
.datepickerclass .mx-datepicker {
  width: 100%;
}
</style>
